import { render, staticRenderFns } from "./pie-group.vue?vue&type=template&id=a2f28f36&scoped=true&"
import script from "./pie-group.vue?vue&type=script&lang=js&"
export * from "./pie-group.vue?vue&type=script&lang=js&"
import style0 from "./pie-group.vue?vue&type=style&index=0&id=a2f28f36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f28f36",
  null
  
)

export default component.exports